import { useMutation } from '@tanstack/react-query';
import { toast } from '@eureca/ui';
import {
  downloadStageResponsesXlsx,
  fetchStageResponses,
  responsesFileName,
  StageResponsesEmptyError,
  StageResponsesNoSurveyError,
} from './export-responses';
import { stageResponsesExportBlocker } from './responses-matrix';

/**
 * Exporta a base de respostas de uma etapa (formulário) para XLSX e dispara o
 * download. Ação imperativa (não uma query reativa) — `useMutation` cuida do
 * estado de loading + toasts. `jobId` é o id da vaga (Core `job`).
 */
export function useExportStageResponses(jobId: string) {
  return useMutation({
    mutationFn: async (input: { moduleId: string; stageName: string }) => {
      const data = await fetchStageResponses(jobId, input.moduleId);
      // Aborta ANTES de gerar o arquivo. Sem o gate de `questions` o XLSX saía
      // com as 4 colunas fixas e zero colunas de resposta — download silencioso
      // com toast de sucesso.
      const blocker = stageResponsesExportBlocker(data);
      if (blocker === 'no-survey') {
        throw new StageResponsesNoSurveyError();
      }
      if (blocker === 'no-candidates') {
        throw new StageResponsesEmptyError();
      }
      await downloadStageResponsesXlsx(data, responsesFileName(input.stageName));
    },
    onSuccess: () => {
      toast('Base de respostas exportada.');
    },
    onError: (err) => {
      if (err instanceof StageResponsesNoSurveyError) {
        toast('Esta etapa não tem formulário vinculado — não há base de respostas para exportar.');
        return;
      }
      if (err instanceof StageResponsesEmptyError) {
        toast('Nenhuma resposta para exportar ainda.');
        return;
      }
      toast.error('Não foi possível exportar as respostas. Tente novamente.');
    },
  });
}
